import { useCallback } from 'react';
import { Platform } from 'react-native';
import { useAppDispatch, useAppStore } from 'store/hooks';
import { getIapSubscriptions, getIsEligibleForIntroOffer } from '../iap';
import { setIapSubscriptions, setIsEligibleForIntroOffer, } from '../actions/iapSubscriptions';
// Dont do the check on dev or it asks for a pw everytime on sim
let hasCheckedThisSession = __DEV__;
const useLoadIapSubscriptions = () => {
    const dispatch = useAppDispatch();
    const store = useAppStore();
    const loadIapSubscriptions = useCallback(async () => {
        const subscriptions = await getIapSubscriptions();
        if (subscriptions.length) {
            dispatch(setIapSubscriptions(subscriptions));
        }
        if (Platform.OS === 'ios' &&
            (!hasCheckedThisSession ||
                store.getState().iapSubscriptions.isEligibleForIntroOffer === undefined)) {
            const isEligibleForIntroOffer = await getIsEligibleForIntroOffer();
            if (isEligibleForIntroOffer !== undefined) {
                hasCheckedThisSession = true;
                dispatch(setIsEligibleForIntroOffer(isEligibleForIntroOffer));
            }
        }
    }, []);
    return loadIapSubscriptions;
};
export default useLoadIapSubscriptions;
